import { ref } from 'vue'
import { backButtonCallback } from '@/router'
import { fetchLiveOpsEvents } from '@/composables/game/live-ops-events'

const showLiveOpsOverlay = ref(false)
const selectedLiveOpsEventId = ref<string | null>(null)

console.log('Loading useLiveOpsOverlay')
export function useLiveOpsOverlay() {
  function openLiveOpsOverlay(eventId: string, onClose?: () => void) {
    selectedLiveOpsEventId.value = eventId
    showLiveOpsOverlay.value = true
    backButtonCallback.value = onClose ?? closeLiveOpsOverlay
  }

  function closeLiveOpsOverlay() {
    showLiveOpsOverlay.value = false
    selectedLiveOpsEventId.value = null
    backButtonCallback.value = null
    fetchLiveOpsEvents()
  }

  return {
    showLiveOpsOverlay,
    selectedLiveOpsEventId,
    openLiveOpsOverlay,
    closeLiveOpsOverlay,
  }
}
